export const currentDay = new Date()
export const currentMonth = currentDay.getMonth()
export const currentYear = currentDay.getFullYear()
export const dateMinus72Hrs = new Date(new Date().setDate(currentDay.getDate() - 3))
export const monthMinus72Hrs = dateMinus72Hrs.getMonth()
export const yearMinus72Hrs = dateMinus72Hrs.getFullYear()
export const lastMonthDate = new Date()
lastMonthDate.setDate(0)
export const lastMonth = lastMonthDate.getMonth()


